import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLoaderData } from "react-router-dom";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import { metaActions } from "@store";

import About from "./blocks/About";
import ProfTestWizard from "../../components/stepwalker/ProfTestWizard";
import { Container } from "react-bootstrap";
function Page(props) {
  const data = useLoaderData();
  const dispatch = useDispatch();
 const apiKey = "7e9247c8-4c61-409a-91c5-c49872daf93e"
  useEffect(() => {
    dispatch(
      metaActions.setData({
        icon: "/faviconSchoolboy.ico",
        title: "Школьники",
        description:
          "Школьники и будущие абитуриенты могут пройти профориентацию, с легкостью выбрать специальность и учебное заведение в Республике Башкортостан",
      })
    ); 
  }, [dispatch]);

  return (
    <div>
      <Animation
        animationIn={animationStyles.swipeLeftIn}
        animationOut={animationStyles.swipeRightOut}
      >
        <About />
      </Animation>
      <Animation>
       <Container> <ProfTestWizard /></Container>
      </Animation>
     
    
    </div>
  );
}

export default Page;
